import { config } from "@/config"

import { BrandIcon } from "@/components/brand-icon"
import { ScrollReveal } from "@/components/scroll-reveal"

export function Footer() {
  return (
    <footer className="text-muted-foreground border-t py-10 text-sm">
      <ScrollReveal
        y={12}
        className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-5 px-4 text-center sm:flex-row sm:px-6 sm:text-left"
      >
        <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
          <BrandIcon />
          <div className="text-center sm:text-left">
            <p className="text-foreground font-semibold">{config.name}</p>
            <p className="text-xs">{config.slogan}</p>
          </div>
        </div>
        <p className="text-muted-foreground text-xs">
          &copy; {new Date().getFullYear()}{" "}
          <span className="text-primary font-bold">{config.name}</span>. All
          rights reserved.
        </p>
      </ScrollReveal>
    </footer>
  )
}
